import * as types from './types';
import * as api from './api';

export const checkfree = (username) => ({
  type: types.checkfree,
  payload: api.checkfree(username)
});

export const languagecombo = () => ({
  type: 'languagecombo',
  payload: api.languagecombo()
});

export const customerdeactivate = (id) => ({
  type: 'customerdeactivate',
  payload: api.customerdeactivate(id)
});

export const customerrectivate = (id) => ({
  type: 'customerrectivate',
  payload: api.customerrectivate(id)
});

export const projectsList = (jobtype, customerid) => ({
  type: types.ASSESSMENT,
  payload: api.projectsList(jobtype, customerid)
});



export const customerdfList = (customerid) => ({
  type: types.CUSTOMERDFLIST,
  payload: api.customerdfList(customerid)
});

export const filesList = (groupId,customerid) => ({
  type: types.filesList,
  payload: api.filesList(groupId,customerid)
});

export const customersList = () => ({
  type: types.customersList,
  payload: api.customersList()
});

export const alldfList = () => ({
  type: types.alldfList,
  payload: api.alldfList()
});


export const checkdfname = (repo,customerid) => ({
  type: types.CHECKDFNAME,
  payload: api.checkdfname(repo,customerid)
});



export const customersPrjList = (jobtype,customerid) => ({
  type: types.customersPrjList,
  payload: api.customersPrjList(jobtype,customerid)
});

export const deletesrccode = (customerid,repo) => ({
  type: 'deletesrccode',
  payload: api.deletesrccode(customerid,repo)
});

export const resetCustomersPrjList = () => ({
  type: 'resetCustomersPrjList'
});

export const resetStagingPrjList = () => ({
  type: 'resetStagingPrjList'
});

// export const customersPrjList_Tran = (jobtype,customerid) => ({
//   type: types.customersPrjList,
//   payload: api.customersPrjList_Tran(jobtype,customerid)
// });

export const userRequest = (
  username,
  reponame,
  srclang,
  tgtlang,
  description,
  jobType,
  customerid
  ) => ({
  type: types.userRequest,
  payload: api.userRequest(
    username,
    reponame,
    srclang,
    tgtlang,
    description,
    jobType,
    customerid
  )
});

export const projectsListfordataengineer = (jobtype, groupId, gitlab_id) => ({
  type: types.ASSESSMENTFORDATA,
  payload: api.projectsList(jobtype, groupId, gitlab_id)
});


export const projectsListForApproveTranslation = (jobtype, groupId, gitlab_id) => ({
  type: types.TRANSAPPROVE,
  payload: api.projectsListForApproveTranslation(jobtype, groupId, gitlab_id)
});

export const assessment = (
  reponame,
  srclang,
  tgtlang,
  description,
  opportunity_num,
  clientname,
  username,
  name,
  customerid,
  projectname
) => ({
  payload: api.assessment(
    reponame,
    srclang,
    tgtlang,
    description,
    opportunity_num,
    clientname,
    username,
    name,
    customerid,
    projectname
  ),
  meta: {
    reponame,
    srclang,
    tgtlang,
    description,
    opportunity_num,
    clientname
  }
});

export const translationworking = (
  username,
  reponame,
  srclang,
  tgtlang,
  description,
  jobType,
  reponamefordataen,
  customerid,
  projectname,
) => ({
  payload: api.translationworking(
    username,
    reponame,
    srclang,
    tgtlang,
    description,
    jobType,
    reponamefordataen,
    customerid,
    projectname,
  )
});


export const createupdatedf = (
  customerid,
  username,
  dfid,
  dfTypeName,
  reponame,
  srclang,
  tgtlang,
  // description,
  // jobType,
  // reponamefordataen,
  // customerid,
  // projectname,
  hive,
  hadoop,
  jdbclistcopyy
) => ({
  payload: api.createupdatedf(
    customerid,
    username,
    dfid,
    dfTypeName,
    reponame,
    srclang,
    tgtlang,
    // description,
    // jobType,
    // reponamefordataen,
    // customerid,
    // projectname,
    hive,
    hadoop,
    jdbclistcopyy
  )
});

export const assessmentfordatasubmit = (
  reponamefordataen,
  reponame,
  srclang,
  tgtlang,
  description,
  opportunity_num,
  clientname,
  username,
  name,
  customerid,
  projectname
) => ({
  type: types.ASSESSMENTFORDATASUBMIT,
  payload: api.assessmentfordatasubmit(
    reponamefordataen,
    reponame,
    srclang,
    tgtlang,
    description,
    opportunity_num,
    clientname,
    username,
    name,
    customerid,
    projectname
  ),
  meta: {
    reponamefordataen,
    reponame,
    srclang,
    tgtlang,
    description,
    opportunity_num,
    clientname
  }
});
export const translation = (
  reponame,
  srclang,
  tgtlang,
  description,
  financialforce_id,
  clientname,
  username,
  name
) => ({
  type: types.TRANSLATION,
  payload: api.translation(
    reponame,
    srclang,
    tgtlang,
    description,
    financialforce_id,  //opportunity_num,
    clientname,
    username,
    name
  ),
  meta: {
    reponame,
    srclang,
    tgtlang,
    description,
    financialforce_id,    //opportunity_num,
    clientname
  }
});

export const saveapprovetranslation = (
  reponame,
  reference_id,
  quotation_id,
  translationRate,
  clientname,
  opportunity_num
) => ({
  type: types.SAVEAPPROVETRANSLATION,
  meta: {
    reponame,
    reference_id,
    quotation_id,
    translationRate,
    clientname,
    opportunity_num
  }
});

export const saveOrderRequest = (
  reponame,
  reference_id,
  quotation_id,
  isOrderConfirmed

) => ({
  type: types.SAVEORDERREQUEST,
  meta: {
    reponame,
    reference_id,
    quotation_id,
    isOrderConfirmed
  }
});

export const selectrole = (
 role
) => ({
  type: types.SELECTROLE,
  meta: {
   role
  }
});

export const changeorderconfirmed = (
  isOrderConfirmed
 ) => ({
   type: types.CHANGEORDERCONFIRMED,
   meta: {
    isOrderConfirmed
   }
 });


export const changeds = (
  description
 ) => ({
   type: types.CHANGEDS,
   meta: {
    description
   }
 });

 export const changesrc = (
  srclang
 ) => ({
   type: types.CHANGESRC,
   meta: {
    srclang
   }
 });

 export const changeoppnum = (
  opportunity_num
 ) => ({
   type: types.CHANGEOPPNUM,
   meta: {
    opportunity_num
   }
 });

 export const changefinid = (
  financialforce_id
 ) => ({
   type: types.CHANGEFINID,
   meta: {
    financialforce_id
   }
 });

 export const changeclientname = (
  clientname
 ) => ({
   type: types.CHANGECLIENTNAME,
   meta: {
     clientname
   }
 });

 export const gethidden = (
  hiddentext
 ) => ({

   type: types.HIDDENTEXT,
   meta: {
    hiddentext
   }
 });


 export const setflag = flag => ({
  type: types.SETFLAG,
  meta: {
    flag
  }
});

export const approvetranslation = (username,reponame,srclang,tglang,description,jobType,reponamefordataen,customerid,reference_id) => ({
  type: types.APPROVETRANSLATION,
  payload: api.approvetranslation(username,reponame,srclang,tglang,description,jobType,reponamefordataen,customerid,reference_id)
});

export const approveassessment = (username,reponame,srclang,tglang,description,jobType,reponamefordataen,customerid,reference_id) => ({
  type: 'approveassessment',
  payload: api.approveassessment(username,reponame,srclang,tglang,description,jobType,reponamefordataen,customerid,reference_id)
});

export const placeorder = (reference_id,quotation_id,username) => ({
  type: types.PLACEORDER,
  payload: api.placeorder( reference_id,quotation_id,username)
});

export const savetranslation = reponame => ({
  type: types.SAVETRANSLATION,
  meta: {
    reponame
  }
});

// export const translation = reponame => ({
//   type: types.TRANSLATION,
//   payload: api.translation(reponame)
// });




export const emailValidation = email => ({
  type: types.EMAILVALIDATION,
  payload: api.emailValidation(email)
});

export const updatePassword = email => ({
  type: types.UPDATEPASS,
  payload: api.updatePassword(email)
});

export const setpopflagfalse = () => ({
  type: types.SETFLAGFALSE
});

export const saveapproval = role => ({
  type: types.SAVEAPPROVAL,
  meta: {
    role
  }
});

export const insertJdbcList = jdbclistcopyy => ({
  type: types.INSERTJDBCLIST,
  meta: {
    jdbclistcopyy
  }
});

export const saverejection = () => ({
  type: types.SAVEREJECTION
});


export const savefinalapprove = () => ({
  type: types.SAVEFINALAPPROVE
});

export const getuser = username => ({
  type: types.USERINFO,
  payload: api.getuser(username)
});

export const stagingPrjList = (jobtype,repo,customerid) => ({
  type: types.stagingPrjList,
  payload: api.stagingPrjList(jobtype,repo,customerid)
});

export const gettranslationstagingforrelease = (jobtype,repo,customerid) => ({
  type: 'gettranslationstagingforrelease',
  payload: api.gettranslationstagingforrelease(jobtype,repo,customerid)
});


export const RequestList = username => ({
  type: types.RequestList,
  payload: api.RequestList(username)
});

export const customerexist = email => ({
  type: "customerexist",
  payload: api.customerexist(email)
});

export const NPRequestList = customer => ({
  type: types.NPRequestList,
  payload: api.NPRequestList(customer)
});

export const downloadPrj = (customerid,projectname) => ({
  type: types.downloadPrj,
  payload: api.downloadPrj(customerid,projectname)
});

export const approve = (username, email, name, role) => ({
  type: types.APPROVE,
  payload: api.approve(username, email, name, role)
});

export const sendfinalapprove = (username, email, name, role) => ({
  type: types.SENDFINALAPPROVE,
  payload: api.sendfinalapprove(username, email, name, role)
});

export const reject = username => ({
  type: types.REJECT,
  payload: api.reject(username)
});

export const forgetpassword = email => ({
  type: types.FORGETPASSWORD,
  payload: api.forgetpassword(email)
});

export const changepassword = (username,password,newpassword) => ({
  type: types.CHANGEPASSWORD,
  payload: api.changepassword(username,password,newpassword)
});

export const customerregister = (
  companyName,
  companyAlias,
  contactFirstName,
  contactLastName,
  contactEmail,
  contactPhoneNumber,
  adminFirstName,
  adminLastName,
  adminEmail,
  adminPhoneNumber
) => ({
  type: types.CUSTOMERREGISTER,
  payload: api.customerregister(
    companyName,
    companyAlias,
    contactFirstName,
    contactLastName,
    contactEmail,
    contactPhoneNumber,
    adminFirstName,
    adminLastName,
    adminEmail,
    adminPhoneNumber
  )
});

export const getreferenceidlist = reponame => ({
  type: types.REFERENCEIDLIST,
  payload: api.getreferenceidlist(reponame)
});

export const resetPopError = reponame => ({
  type: 'RESET_STATUS',
});

export const resolveToken = token => ({
  type: 'resolveToken',
  payload: api.resolveToken(token)
});


export const getinfobyreferenceid = reference_id => ({
  type: types.TRANSLATIONAPPROVEBYREFERENCEID,
  payload: api.getinfobyreferenceid(reference_id),
  meta: {
    reference_id
  }
});

export const getinfobyreferenceidForApprove = reference_id => ({
  type: types.TRANSLATIONAPPROVEBYREFERENCEIDFORQUOTE,
  payload: api.getinfobyreferenceidforquo(reference_id),
  meta: {
    reference_id
  }
});

export const getRptInfobyreferenceid = reference_id => ({
  type: types.DOWNLOADRPTBYREFERENCEID,
  payload: api.getinfobyreferenceid(reference_id),
  meta: {
    reference_id
  }
});

export const getinfobyusernameandreferenceid = (clientname,reference_id) => ({
  type: types.DOWNLOADRPTBYUSERNAMEANDREFERENCEID,
  payload: api.getinfobyusernameandreferenceid(clientname,reference_id),
  meta: {
    reference_id
  }
});

export const getRptLnkbyreferenceid = reference_id => ({
  type: types.GETRPTLNKBYREFERENCEID,
  meta: {
    reference_id
  }
});

export const getQuotbypo = quotation_id => ({
  type: types.GETQUOTBYPO,
  payload: api.getquotbypo(quotation_id),
  meta: {
   // reference_id,
   quotation_id
  }
});

export const saveMemberName = username => ({
  type: types.SAVEMEMBERNAME,
  meta: {
    username
  }
});

export const savequo = quotation_id => ({
  type: types.KEEPQUO,
  meta: {
    quotation_id
  }
});

export const downloadRpt = reference_id => ({
  type: types.DOWNLOADREPORT,
  payload: api.downloadRpt(reference_id),
  meta: {
    reference_id
  }
});

export const TransdownloadRpt = reference_id => ({
  type: types.TRANSDOWNLOADREPORT,
  //payload: api.transdownloadRpt(reference_id),
  payload: api.downloadRpt(reference_id),
  meta: {
    reference_id
  }
});
export const getinfobyponumber = po_num => ({
  type: types.TRANSLATIONBYPONUMBER,
  payload: api.getinfobyponumber(po_num)
});


export const getinfobyreponame = (reponame,customerid,jobtype) => ({
  type: types.TRANSLATIONBYREPONAME,
  payload: api.getinfobyreponame(reponame,customerid,jobtype)
});

export const gensourcetest = (dfname, prname,dfid,prid,runtest) => ({
  type: types.GENSOURCETEST,
  payload: api.gensourcetest(dfname,prname,dfid,prid,runtest)
});

export const checkddlexist = (customerid,dfname,page) => ({
  type: types.checkddlexist,
  payload: api.checkddlexist(customerid,dfname,page)
//  meta: {
//   dfname
// }
});

export const checkddlexistjdbc = (customerid,dfname,jdbc) => ({
  type: types.checkddlexistjdbc,
  payload: api.checkddlexistjdbc(customerid,dfname,jdbc)
//  meta: {
//   dfname
// }
});


export const checkexistunitest = (projectid) => ({
  type: types.checkexistunitest,
  payload: api.checkexistunitest(projectid)
//  meta: {
//   dfname
// }
});


export const getinfobyreponameforaccessment = (reponame,customerid) => ({
  type: types.ACCESSMENTBYREPONAME,
  payload: api.getinfobyreponameforaccessment(reponame,customerid)
});

export const reactiveUser = (username, email, adminUsername) => ({
  type: 'reactiveUser',
  payload: api.reactiveUser(username, email, adminUsername)
});

export const usersList = username => ({
  type: types.USERSLIST,
  payload: api.usersList(username)
});

export const dfusersList = username => ({
  type: types.DFUSERSLIST,
  payload: api.dfusersList(username)
});

export const addusertodf = (userid,dfid) => ({
  type: types.ADDUSERTODF,
  payload: api.addusertodf(userid,dfid)
});

export const removeusertodf = (userid,dfid) => ({
  type: types.REMOVEUSERTODF,
  payload: api.removeusertodf(userid,dfid)
});

export const delgetdfusersList = (dfuserid,dfid) => ({
  type: types.DELGETDFUSERSLIST,
  payload: api.delgetdfusersList(dfuserid,dfid)
});

export const getuserlistnotindf = (customerid,dfid) => ({
  type: types.GETUSERLISTNOTINDF,
  payload: api.getuserlistnotindf(customerid,dfid)
});

export const changeowner = (newownerid,newonername,dfactoryid) => ({
  type: types.CHANGEOWNER,
  payload: api.changeowner(newownerid,newonername,dfactoryid)
});
export const changeAdmin = (oldAdmin,newAdmin) => ({
  type: 'changeAdmin',
  payload: api.changeAdmin(oldAdmin,newAdmin)
});

export const usersapproveList = username => ({
  type: 'usersapproveList',
  payload: api.usersapproveList(username)
});

export const customerApprove = id => ({
  type: 'customerApprove',
  payload: api.customerApprove(id)
});


export const resetAssessmentStore = () => ({
  type: types.RESET_ASSESSMENT_STORE
});

export const register = (firstName, lastName, email, phoneNumber,adminUsername,role,customerid) => ({
  type: types.REGISTER,
  payload: api.register(firstName, lastName, email, phoneNumber,adminUsername,role,customerid),
  meta: {
    firstName,
    lastName,
    email,
    phoneNumber,
    adminUsername,
    role,
    customerid
  }
});

export const unregister = (username, email, adminUsername) => ({
  type: types.UNREGISTER,
  payload: api.unregister(username, email, adminUsername),
  meta: {
    username,
    email,
    adminUsername
  }
});



// WEBPACK FOOTER //
// ./src/state/assessment/actions.js